export default __webpack_public_path__ + "static/media/multiple.61cd8b06.png";